// src/utils/haptics.js

export const triggerHaptic = (style) => {
  // Проверяем, что мы внутри Telegram WebApp
  if (!window.Telegram?.WebApp?.HapticFeedback) return;

  const haptic = window.Telegram.WebApp.HapticFeedback;

  // Если это статус уведомления (успех/ошибка/предупреждение)
  if (['error', 'success', 'warning'].includes(style)) {
    haptic.notificationOccurred(style);
  } 
  // Если это физический отклик (легкий/средний/тяжелый)
  else {
    // Если передан неизвестный стиль, используем 'medium' по умолчанию
    const validImpacts = ['light', 'medium', 'heavy', 'rigid', 'soft'];
    const safeStyle = validImpacts.includes(style) ? style : 'medium';
    
    haptic.impactOccurred(safeStyle);
  }
};

export const triggerNotification = (type) => {
    // Алиас для удобства, если где-то используется старый вызов
    triggerHaptic(type);
};
